document.querySelectorAll('img').forEach(img => {
  img.addEventListener('touchstart', () => {
    img.style.transform = 'scale(1.2)';
    img.style.transition = 'transform 0.3s ease';
  });
  img.addEventListener('touchend', () => {
    img.style.transform = 'scale(1)';
  });
  img.addEventListener('touchcancel', () => {
    img.style.transform = 'scale(1)';
  });
});

